module.exports = __webpack_public_path__ + "static/media/logo.489a4840.png";